export default "__VITE_ASSET__mj7lKriA__"